import OrderModal from './order-modal';

export default OrderModal;